import { ACTUALIZA_CARGADO } from "../constants/actions-types";

const defaultCargando = {
	progreso: 100, 
	mensaje:""
};

function cargandoReducer (state = defaultCargando, action){
	if(action.type === ACTUALIZA_CARGADO){
		let newState = {...state};
		if(action.cargando.progreso >= 100){
			newState.progreso = 100;
			newState.mensaje = "Terminado";
		}else {
			newState.progreso = action.cargando.progreso;
			newState.mensaje = action.cargando.mensaje;
		}
		return newState;
	}
	return state;
}

export default cargandoReducer;